import { useEffect } from 'react';

import { Navigate, useLocation, useNavigate } from 'react-router';

import { LoadingScreen } from '@/components';
import { useAuth, useSessionSync } from '@/hooks';
import { MainLayout } from '@/layouts';
import { APP_ROUTES, Router } from '@/routes';
import { injectAhaWidget } from '@/utils';

import '@fontsource/open-sans/latin-400.css';
import '@fontsource/open-sans/latin-500.css';
import '@fontsource/open-sans/latin-600.css';
import '@fontsource/open-sans/latin-700.css';
import '@/styles/global.scss';

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();
  useSessionSync();

  useEffect(() => {
    if (auth.user?.access_token) {
      injectAhaWidget(auth.user?.access_token);
    }
  }, [auth, location, navigate]);

  if (auth.isLoading) {
    return <LoadingScreen />;
  }

  if (!auth.isAuthenticated) {
    return (
      <button type="button" onClick={() => void auth.signinRedirect()}>
        Log in
      </button>
    );
  }

  if (location.pathname === '/') {
    return <Navigate to={APP_ROUTES.aires} />;
  }

  return (
    <MainLayout>
      <Router />
    </MainLayout>
  );
}

export default App;
